import React from 'react'
import styled from 'styled-components'
import CTASection from '../components/sections/CTASection'
import MainFAQSection from '../components/sections/MainFAQSection'
import FeaturesSection from '../components/sections/FeaturesSection'
import InstructionSection from '../components/sections/InstructionSection'
import MainSection from '../components/sections/MainSection'
import MissionSection from '../components/sections/MissionSection'
import ScrollSection from '../components/sections/ScrollSection'
import useCleanupGsap from '../hooks/useCleanupGsap'

export default function MainPage() {
	useCleanupGsap()

	return (
		<Block>
			<MainSection />
			<ScrollSection />
			<MissionSection />
			<FeaturesSection />
			<InstructionSection />
			<MainFAQSection />
			<CTASection />
		</Block>
	)
}

const Block = styled.div`
	min-height: 100vh;
`
